angular.module('autoremind.directives')
    .directive('comment', ['$compile', 'jobService', function ($compile, jobService) {
        return {
            restrict: 'E',
            scope: true,
            replace: false,
            transclude: false,
            template: '<span class="label2 label-info" uib-tooltip="Context based parameter that will be replaced when sending each message">{{label}}&nbsp;<span ng-click="$parent.remove($event.target.parentElement.parentElement); updateView()">&times;</span></span> ',
            // TODO: Find better way to make caret (cursor) skip properly over to right after the template - without added space
            /*scope: {
                label: '=name', // bind name from <comment name=..> to label to use in the template
            },*/
            compile: function (element, attrs) {
                // do one-time configuration of element.
                element.attr('contenteditable', false);
                var linkFunction = function (scope, element, attrs) {
                    // bind element to data in $scope
                    scope.label = attrs['label'];
                    //scope.jobService = jobService;
                };
                return linkFunction;
            }
        };
    }]);
//# sourceMappingURL=comment.directive.js.map